import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { AdSpaceMediaTypeInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  mediaTypeToUpdate: AdSpaceMediaTypeInterface | null;
  setMediaTypeToUpdate: React.Dispatch<React.SetStateAction<AdSpaceMediaTypeInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const AdSpaceMediaTypesUpdateDialog: React.FC<Props> = ({
  open,
  mediaTypeToUpdate,
  setMediaTypeToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update Ad Space Media Type</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="Name"
        value={mediaTypeToUpdate?.name ?? ''}
        onChange={e => setMediaTypeToUpdate(m => m ? { ...m, name: e.target.value } : m)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Description"
        value={mediaTypeToUpdate?.description ?? ''}
        onChange={e => setMediaTypeToUpdate(m => m ? { ...m, description: e.target.value } : m)}
        fullWidth
        margin="dense"
      />
      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={mediaTypeToUpdate?.active !== undefined ? (mediaTypeToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setMediaTypeToUpdate(m => m ? { ...m, active: e.target.value === 'yes' } : m)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);